import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { SAVED_PROPERTIES_QUERY } from '@general/graphql/properties.graph';

const useSavedProperties = (options = {}) => {
    const [savedProperties, setSavedProperties] = useState();
    const { data, ...rest } = useQuery(SAVED_PROPERTIES_QUERY, options);

    useEffect(() => {
        if (!data) {
            return;
        }

        setSavedProperties(data.savedProperties);
    }, [data]);

    return { data: savedProperties, ...rest };
};

export default useSavedProperties;
